import { cn } from "@/lib/utils";
import type { ClientHealthStatus } from "@/types/api/client-health";

/** Time ranges offered on the Client health pages (days). */
export const RANGES = [
	{ days: 1, label: "24 hours" },
	{ days: 7, label: "7 days" },
	{ days: 30, label: "30 days" },
] as const;

export function StatusBadge({ status }: { status: ClientHealthStatus }) {
	return (
		<span
			className={cn(
				"rounded px-2 py-0.5 text-xs font-medium",
				status === "Errors" &&
					"bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-200",
				status === "Healthy" &&
					"bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200",
				status === "Quiet" &&
					"bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
			)}
		>
			{status}
		</span>
	);
}
